import { Injectable } from '@angular/core';

import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';

import { AppSettings } from './../app.settings';
import { LRSMap } from 'assets/TS/LRSMap_New';

@Injectable()
export class ArcmapConnectService {

	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }

	// To open map in ArcMap
	// projection: 'EPSG:XXXX'
	// extent: [xmin, ymin, xmax, ymax]
	postMapExtent(extent: number[], projection: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/extent';
			const body = {
				email: this.userService.getUserInfo().userEmail,
				projection: Number(projection.split(':')[1]),
				extent: JSON.stringify({
					xmin: extent[0],
					ymin: extent[1],
					xmax: extent[2],
					ymax: extent[3]
				})
			};
			this.requestService.requestPost(url, body, (rsp) => {
				resolve();
			}, (err) => {
				reject();
			});
		});
	}

	// Send map info to arcmap
	noticeArcMap(map: LRSMap.Map) {
		const extent = map.olMap.getView().calculateExtent(map.olMap.getSize());
		const projection = map.olMap.getView().getProjection().getCode();
		this.postMapExtent(extent, projection);
	}

}
